/**
 * Screens one application links to in ANOTHER application (followed through
 * `CrossAppLink`, which keeps the Identity session). Kept here so the target
 * application's route and the source's link cannot drift apart: the Finance
 * routes below are the Finance web app's own `PATHS`.
 */
export const FINANCE_APP_PATHS = {
  assets: '/finance/asset-management/assets',
  assetDetail: (assetId: string) => `/finance/asset-management/assets/${assetId}`,
  accessUser: (userId: string) => `/access/users/${userId}`,
  employeePermissions: (employeeId: string) => `/access/employees/${employeeId}/permissions`,
} as const;

export const HRMS_APP_PATHS = {
  projects: '/projects',
  employeeProfile: (employeeId: string) => `/employees/${employeeId}`,
  projectDetail: (projectId: string) => `/projects?view=${projectId}`,
} as const;
